import {
  isSimulateAllChannelsEnabled,
  isSimulateFeatureAllowed,
} from '@/lib/dev/simulateAllChannelsConnected.js';

/**
 * Visible dev/test banner when ?simulate=on is active (Gate 7.1j J3).
 */
export function SimulatedChannelsBanner() {
  if (!isSimulateFeatureAllowed() || !isSimulateAllChannelsEnabled()) {
    return null;
  }

  return (
    <div
      role="status"
      className="fixed bottom-0 left-0 right-0 z-[9999] border-t border-amber-300 bg-amber-50 px-4 py-2 text-center text-xs font-semibold tracking-wide text-amber-900 shadow-[0_-2px_8px_rgba(0,0,0,0.06)]"
      data-testid="simulated-channels-banner"
    >
      SIMULATED CHANNELS ON
    </div>
  );
}
